import React from 'react';
import { connect } from 'react-redux';
import {
  offerCommentsQuery,
  commentLikeMutation,
  commentunLikeMutation,
} from '../../../apollo';
import { withAlertHandler } from 'entoro-shared';
import { withApollo } from 'react-apollo';
import FavoriteIcon from 'material-ui-icons/Favorite';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const Like = ({
  comment,
  _id,
  offer,
  client,
  handleSnackbarError,
  setSnackbarMessage,
}) => {
  const MySwal = withReactContent(Swal);
  const Toast = MySwal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', MySwal.stopTimer);
      toast.addEventListener('mouseleave', MySwal.resumeTimer);
    },
  });

  const checkIsLike = () => {
    if (!comment.likes) return false;
    //this tells if authenticated user has already liked
    return comment.likes.some((like) => {
      return like.investorUserId === _id;
    });
  };

  const like = async () => {
    //   alert(JSON.stringify(values));
    const { mutate } = client;
    const refetchQueries = [
      {
        query: offerCommentsQuery,
        variables: {
          offerId: offer._id,
        },
      },
    ];
    const variables = {
      commentId: comment._id,
    };
    try {
      const { data } = await mutate({
        mutation: commentLikeMutation,
        variables,
        refetchQueries,
      });

      if (data.commentLike) {
        //dispatch(reset('commentForm'));
        //comment added
        Toast.fire({
          icon: 'success',
          title: 'Liked successfully',
        });
      }
    } catch (error) {
      handleSnackbarError(error);
    }
  };

  const unlike = async () => {
    const { mutate } = client;
    const refetchQueries = [
      {
        query: offerCommentsQuery,
        variables: {
          offerId: offer._id,
        },
      },
    ];
    const variables = {
      commentId: comment._id,
    };

    try {
      const { data } = await mutate({
        mutation: commentunLikeMutation,
        variables,
        refetchQueries,
      });

      if (data.commentunLike) {
        //dispatch(reset('commentForm'));
        //comment added
        Toast.fire({
          icon: 'success',
          title: 'Unliked successfully',
        });
      }
    } catch (error) {
      handleSnackbarError(error);
    }
  };

  return (
    <button
      className='btn-small-outline'
      onClick={checkIsLike() ? unlike : like}
    >
      <FavoriteIcon
        className={`like_icon ${checkIsLike() && 'like_icon_red'}`}
      />
      {comment.likes && comment.likes.length}
    </button>
  );
};

const mapStateToProps = ({ investorUser = {} }, { offerId }) => {
  const { _id } = investorUser;

  return {
    _id,
  };
};

export default connect(mapStateToProps)(withApollo(withAlertHandler(Like)));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/Comments/Like.js